export default __webpack_public_path__ + "static/media/customerrankicon.be4c0b4a.svg";